import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Box, Modal } from '../../../../components/mui/Core/index'
import { styled } from '../../../../components/mui/Styles/index'
import UpdateUserRole from './components/UpdateUserRole/update-user-role'
import SelectRoleForUpdate from './components/SelectRoleForUpdate/select-role-for-update'
import UpdateUserRoleNavigation from './components/UpdateUserRoleNavigation/update-user-role-navigation'

const CenteredContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  minHeight: '229px',
  width: '496px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.common.white,
  border: 'none !important',
  borderRadius: '12px',
  boxShadow: 24,
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingTop: '20px',
  paddingBottom: '20px',
}))

// eslint-disable-next-line react/prop-types
function UserRoleUpdateModal({ isOpen, handleCloseAction, handleSubmitAction, selectedUser }) {
  const currentStep = useSelector((state) => state.updateUserRole.currentStep)

  function getCurrentStep() {
    switch (currentStep) {
      case 1:
        return <SelectRoleForUpdate selectedUser={selectedUser} />
      case 2:
        return <UpdateUserRole selectedUser={selectedUser} />
      default:
        return null
    }
  }

  return (
    <Modal disableEscapeKeyDown open={isOpen} onClose={handleCloseAction}>
      <CenteredContainer>
        {getCurrentStep()}
        <Box>
          <UpdateUserRoleNavigation
            handleCloseAction={handleCloseAction}
            handleSubmitAction={handleSubmitAction}
          />
        </Box>
      </CenteredContainer>
    </Modal>
  )
}

UserRoleUpdateModal.prototype = {
  // eslint-disable-next-line react/forbid-prop-types
  selectedUser: PropTypes.array.isRequired,
  isOpen: PropTypes.bool,
  handleCloseAction: PropTypes.func,
  handleSubmitAction: PropTypes.func,
}

export default UserRoleUpdateModal
